import { axiosClient, getCSRFToken } from 'www/utils'
import { getConcatOptionGET } from 'www/vue_components/common/Analyses/functions/getConcatOptionGET'
import { RequestAnalysesList } from 'www/vue_components/common/Analyses/types'
import { ResponseLabList, RequestLabList } from 'www/vue_components/common/Analyses/components/LaboratoriesList/types'
import { RequestCategoriesList, ResponseCategoriesList } from 'www/vue_components/common/Analyses/components/CategoriesList/types'

export function getAnalysesList(payload: RequestAnalysesList) {
  return axiosClient.get(getConcatOptionGET({
    path: '/ajax/diagnostika/analyses/partner/',
    payload,
  }))
}

export function getCategoriesList(payload: RequestCategoriesList): Promise<{
  data: {
    categories: ResponseCategoriesList
    total_pages_number: number
  }
}> {
  return axiosClient.get(getConcatOptionGET({
    path: `/ajax/diagnostika/analyses/${payload.townTranslit}/partner/${payload.partnerSlug}/categories/`,
    payload: {
      search: payload.searchString,
      page: payload.page,
      lpu_id: payload.lpuId,
    },
  }))
}

export function getLaboratoriesList(payload: RequestLabList): Promise<{ data: ResponseLabList }> {
  return axiosClient.get(getConcatOptionGET({
    path: `/ajax/diagnostika/analyses/${payload.townTranslit}/partner/${payload.partnerSlug}/labs/`,
    payload: {
      search: payload.searchString,
      page: payload.page,
      has_cart_analyzes: payload.hasCartAnalyzes,
      category_slug: payload.categorySlug,
    },
  }))
}

export function addAnalysisToCart(synonymId: number, partnerSlug: string, biomaterialId: number) {
  return axiosClient.post(
    '/ajax/diagnostika/analyses/cart/',
    {
      analysis_synonym_id: synonymId,
      biomaterial_id: biomaterialId,
      partner_slug: partnerSlug,
    },
    {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    },
  )
}

export function deleteAnalysisFromCart(opts: {
 synonymId: number,
 biomaterialId: number,
 townTranslit?: string,
 isReturnCartContent?: boolean,
 lpuId?: number,
}) {
  return axiosClient.delete('/ajax/diagnostika/analyses/cart/', {
    data: {
      analysis_synonym_id: opts.synonymId,
      biomaterial_id: opts.biomaterialId,
      town: opts.townTranslit,
      return_cart: opts.isReturnCartContent,
      lpu_id: opts.lpuId,
    },
    headers: {
      'X-CSRFToken': getCSRFToken(),
    },
  })
}

export function deleteAllAnalysesFromCart() {
  return axiosClient.delete(
    '/ajax/diagnostika/analyses/cart/',
    {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    },
  )
}
